import UIkit from 'uikit'
import axios from 'axios'
import _ from 'lodash'

import Hub from '../events/Hub'
import store from '../store'

import apiMixin from './apiMixin'
import brandingMixin from './brandingMixin'
import MZCApiService from '../services/mzcapi'

// let appConfigs = require(`../assets/client/${process.env.CLIENTID}/site_config.json`)

export default {
  mixins: [apiMixin, brandingMixin],
  data () {
    return {
      dev: {
        textarea: 'Welcome to Developer Tools',
        fakeCode: 'https://redeemqr.com/Yokalize/al/b8d04830-5256-4da9-bab1-0799e76c4a50'
      },
      mountedCalled: false,
      firstRunGPSCalled: false,
      onDeckRedemption: null,
      baseURLroot: 'https://secure-dev.mzcapi.com/api/',
      redemptionIntentPayload: {}
    }
  },
  computed: {
    todaysHours: function () {
      let _this = this
      let getHOO = _.get(_this.location, 'meta_data.hoursOfOperation', false)
      if (getHOO) {
        let _this = this
        let daysOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
        let theDate = new Date()
        let numericDay = theDate.getDay()
        let todaysStart = daysOfWeek[numericDay] + '_open'
        let todaysEnd = daysOfWeek[numericDay] + '_close'
        let todayOpenTime = _this.location.meta_data.hoursOfOperation[todaysStart]
        let todayCloseTime = _this.location.meta_data.hoursOfOperation[todaysEnd]
        // Convert 24 hour time to 12 hour time with AM/PM
        let todayOpenTime12hr = new Date('1970-01-01T' + todayOpenTime + 'Z').toLocaleTimeString({}, {timeZone: 'UTC', hour12: true, hour: '2-digit', minute: '2-digit'})
        let todayCloseTime12hr = new Date('1970-01-01T' + todayCloseTime + 'Z').toLocaleTimeString({}, {timeZone: 'UTC', hour12: true, hour: '2-digit', minute: '2-digit'})
        // Check if the location is closed
        if (todayOpenTime === 'Closed' || todayCloseTime === 'Closed') {
          return 'Closed'
        } else {
          return todayOpenTime12hr + ' - ' + todayCloseTime12hr
        }
      } else {
        return 'Hours of Operation Unavailable.'
      }
    }
  },
  methods: {
    logToArea: function (data) {
      let _this = this
      _this.dev.textarea = _this.dev.textarea + '\n' + data
    },
    nowInUtc: function () {
      let date = new Date()
      let nowUtc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
        date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds())

      return new Date(nowUtc)
    },
    nowDateInUtc: function () {
      let date = this.nowInUtc()

      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      date.setMilliseconds(0)

      return date
    },
    onTouchStartStamp: function (event) {
      let _this = this
      // console.log(_this.redemptionIntentPayload)
      // console.log('touch')
      if (event.touches.length >= 5) {
        let data = []
        let touches = event.touches
        for (let i = 0; i <= event.touches.length; i++) {
          if (touches[i]) {
            data.push([touches[i].pageX, touches[i].pageY])
          }
        }
        _this.sendStamp(data)
      }
    },
    sendStamp: function (data) {
      let _this = this
      let urlPath = _this.baseURLroot
      let _dataForPost = 'data=' + _this.base64Encode(JSON.stringify(data))
      axios.post(urlPath + 'callbacks/postStamp', _dataForPost)
        .then(function (response) {
          let redemptionIntentPayloadRequest = store.getters.getRedemptionIntentPayloadRequest
          // console.log(redemptionIntentPayloadRequest)
          // console.log('SUCCESS=>>>>>>')
          // console.log(response)
          let code = response.data.stamp.serial
          // console.log(code)
          redemptionIntentPayloadRequest.result.code = code
          // console.log(redemptionIntentPayloadRequest)
          UIkit.modal('#ss-modal-center').hide()
          _this.redemptionValidationProcess(redemptionIntentPayloadRequest)
        }).catch(function (error) {
          if (error.response) {
          // console.log(error.response.data)
          // console.log(error.response.status)
          // console.log(error.response.headers)
          }
        })
    },
    base64Encode: function (input) {
      let _this = this
      let _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
      let output = ''
      let chr1, chr2, chr3, enc1, enc2, enc3, enc4
      let i = 0
      input = _this.utf8Encode(input)
      while (i < input.length) {
        chr1 = input.charCodeAt(i++)
        chr2 = input.charCodeAt(i++)
        chr3 = input.charCodeAt(i++)
        enc1 = chr1 >> 2
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
        enc4 = chr3 & 63
        if (isNaN(chr2)) {
          enc3 = enc4 = 64
        } else if (isNaN(chr3)) {
          enc4 = 64
        }
        output = output +
          _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
          _keyStr.charAt(enc3) + _keyStr.charAt(enc4)
      }
      return output
    },
    utf8Encode: function (string) {
      string = string.replace(/\r\n/g, '\n')
      let utftext = ''
      for (let n = 0; n < string.length; n++) {
        let c = string.charCodeAt(n)
        if (c < 128) {
          utftext += String.fromCharCode(c)
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192)
          utftext += String.fromCharCode((c & 63) | 128)
        } else {
          utftext += String.fromCharCode((c >> 12) | 224)
          utftext += String.fromCharCode(((c >> 6) & 63) | 128)
          utftext += String.fromCharCode((c & 63) | 128)
        }
      }
      return utftext
    },
    /**
     *Incoming Redemption Request
     *@param method (auto, scan or stamp)
     *@param intent (earn-loyalty, redeem-loyalty, or redeem voucher)
     *@param requestPayload
     */
    redemptionRequested: function (method, intent, requestPayload) {
      console.log('Redemption Requested')
      let _this = this
      _this.onDeckRedemption = {method: method, intent: intent, requestPayload: requestPayload}
      Hub.$emit('prompt-if-user-wants-redemption', _this.onDeckRedemption)
    },
    refreshLocationChanged (coords) {
      let _this = this
      // console.log('location ref')
      // Clear Vuex-ORM
      store.state.current_page = 1
      console.log('Refresh Location Changed - deleting all local cache.')
      store.dispatch('entities/deleteAll')
      _this.dataPull().getInitialData(coords)
    },
    redemptionIntent: function (method, intent, requestPayload, possibleDoubleSidedLoyalty = false) {
      let _this = this
      _this.logToArea('Redemption Intent Called')
      // console.log('Redemption Intent Called')
      Hub.$emit('redemption-method-called', method)
      _this.redemptionIntentPayload = {'success': true, 'method': method, 'intent': intent, 'result': requestPayload}
      // console.log(JSON.stringify(_this.redemptionIntentPayload))
      this.$store.dispatch('setRedemptionIntent', _this.redemptionIntentPayload)
        .then()

      if (method === 'auto') {
        if (window.cordova) {
          method = 'scan'
        } else {
          method = 'stamp'
        }
      }

      switch (method) {
        case 'scan':
          window.cordova.plugins.barcodeScanner.scan(
            (result) => {
              // console.log('Scan Success')
              // If Result Contains XXXXX

              // ELSE
              let payload = {
                'success': true,
                'method': method,
                'intent': intent,
                'result': {storeId: requestPayload.storeId, itemId: requestPayload.itemId, code: result.text}
              }
              Hub.$emit('redemption-validation-code-input-success', payload)
              _this.redemptionValidationProcess(payload)
            },
            (error) => {
              if (error) {
                Hub.$emit('redemption-validation-code-input-fail',
                  {'success': false, 'method': method, 'intent': intent, 'result': error}
                )
              }
            }
          )
          break
        case 'stamp':
          // Hub.$emit('stamp-screen-open-request', payload)
          // Stamp
          UIkit.modal('#ss-modal-center').show()
          break
        case 'internal-redeem':
          Hub.$emit('redemption-validation-code-input-success', _this.redemptionIntentPayload)
          _this.redemptionValidationProcess(_this.redemptionIntentPayload)
          break
        case 'test-success':
          // console.log('test-success function')
          Hub.$emit('redemption-validation-code-input-success', _this.redemptionIntentPayload)
          _this.redemptionValidationProcess(_this.redemptionIntentPayload)
          break
        case 'test-fail':
          Hub.$emit('redemption-validation-code-input-fail',
            {'success': false, 'method': method, 'intent': intent, 'result': requestPayload}
          )
          break
        case 'self':
          Hub.$emit('redemption-validation-code-input-success', _this.redemptionIntentPayload)
          _this.redemptionValidationProcess(_this.redemptionIntentPayload)
          break
        case 'barcode':
          // window.alert('here')
          // window.alert(intent)
          if (intent === 'earn-loyalty') {
            window.cordova.plugins.barcodeScanner.scan(
              (result) => {
                let urlJs = new URL(result.text)
                let path = urlJs.pathname
                let pathSplit = path.split('/')
                let type = pathSplit[2]
                let derivedCode = pathSplit[3]
                if (type === 'al') {
                  let payload = {
                    'success': true,
                    'method': method,
                    'intent': 'earn-loyalty-takeout',
                    'result': {storeId: requestPayload.storeId, itemId: requestPayload.itemId, code: derivedCode}
                  }
                  Hub.$emit('redemption-validation-code-input-success', payload)
                  _this.redemptionValidationProcess(payload)
                }
              },
              (error) => {
                if (error) {
                  Hub.$emit('redemption-validation-code-input-fail',
                    {'success': false, 'method': method, 'intent': intent, 'result': error}
                  )
                }
              }
            )
          }
          Hub.$emit('show-barcode',
            {'intent': intent}
          )
          break
        case 'qr-code':
          window.cordova.plugins.barcodeScanner.scan(
            (result) => {
              // console.log('Scan Success')
              let payload = {'success': true, 'method': method, 'intent': 'earn-loyalty-receipt-qr', 'result': result.text}
              Hub.$emit('redemption-validation-code-input-success', payload)
              _this.redemptionValidationProcess(payload)
            },
            (error) => {
              if (error) {
                Hub.$emit('redemption-validation-code-input-fail',
                  {'success': false, 'method': method, 'intent': 'earn-loyalty-receipt-qr', 'result': error}
                )
              }
            }
          )
          break
        default:
      }
    },
    redemptionValidationProcess: function (payload) {
      // console.log(payload)
      let _this = this
      // Grab the Code
      let _theValidationCodePayload = payload.result

      if (_theValidationCodePayload !== null) {
        let _code = _theValidationCodePayload.code
        let _itemId = _theValidationCodePayload.itemId
        let _storeId = _theValidationCodePayload.storeId
        switch (payload.intent) {
          case 'earn-loyalty-takeout':
            console.log('take out')
            _this.redemption().transactTakeoutLoyalty(_code)
              .then(function (response) {
                console.log(response)
                Hub.$emit('post-loyalty-earn-response-success', response)
                let loyaltyProgramId = response.data.data.loyalty_program_id
                // Refresh Loyalty
                _this.dataPull().getLoyaltyProgramRefresh(loyaltyProgramId)
              })
              .catch(function (error) {
                Hub.$emit('post-loyalty-earn-response-fail', error)
              })
            break
          case 'earn-loyalty':
            _this.redemption().transactGeneral(_code)
              .then(function (response) {
                Hub.$emit('post-loyalty-earn-response-success', response)
                let loyaltyProgramId = response.data.data.loyalty_program_id
                // Refresh Loyalty
                _this.dataPull().getLoyaltyProgramRefresh(loyaltyProgramId)
              })
              .catch(function (error) {
                Hub.$emit('post-loyalty-earn-response-fail', error)
              })
            break
          case 'earn-loyalty-receipt-qr':
            _this.redemption().transactEarnLoyaltyQr(_theValidationCodePayload)
              .then(function (response) {
                Hub.$emit('post-loyalty-earn-response-success', response)
                let loyaltyProgramId = response.data.data.loyalty_program_id
                // Refresh Loyalty
                _this.dataPull().getLoyaltyProgramRefresh(loyaltyProgramId)
              })
              .catch(function (error) {
                Hub.$emit('post-loyalty-earn-response-fail', error)
              })
            break
          case 'redeem-loyalty':
            //
            _this.redemption().transactLoyaltyRedeem(_storeId, _itemId)
              .then(function (response) {
                Hub.$emit('post-loyalty-redeem-response-success', response)
                let loyaltyProgramId = response.data.data.loyalty_redemption.data.loyalty_program_id
                _this.dataPull().getLoyaltyProgramRefresh(loyaltyProgramId)
              })
              .catch(function (error) {
                Hub.$emit('post-loyalty-redeem-response-fail', error)
              })
            break
          case 'redeem-voucher':
            //
            _this.redemption().transactCouponRedeem(_code, _itemId)
              .then(function (response) {
                Hub.$emit('post-voucher-redemption-response-success', response)
                let couponId = response.data.data.coupon.id
                _this.dataPull().getCouponRefresh(couponId)
              })
              .catch(function (error) {
                console.log('Major Error')
                console.log(error)
                Hub.$emit('post-voucher-redemption-response-fail', error)
              })
            break
          case 'self-redeem-voucher':
            //
            _this.redemption().transactSelfCouponRedemption(_storeId, _itemId)
              .then(function (response) {
                response.data.data.coupon = response.data.data.coupon.data
                // eslint-disable-next-line no-unused-vars
                let couponId = response.data.data.coupon.id
                console.log('SELF-REDEEM-VOUCHER')
                console.log(response)
                Hub.$emit('post-voucher-redemption-response-success', response)
                // _this.dataPull().getCouponRefresh(couponId)
              })
              .catch(function (error) {
                console.log('Major Error')
                console.log(error)
                // Hub.$emit('post-voucher-redemption-response-fail', error)
              })
            break
        }
      }
    },
    locationHelpers: function () {
      return {
        // Gets the current coordinates
        getCoordinates: function () {
          // window.alert('Core Mixin - Request Location')
          if (navigator.geolocation) {
            return new Promise(
              (resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject)
            )
          } else {
            return new Promise(
              resolve => resolve({})
            )
          }
        },
        haversineDistance: function (latlngA, latlngB, isMiles) {
          // console.log('hs called')
          const toRad = x => (x * Math.PI) / 180
          const R = 6371 // km

          const dLat = toRad(latlngB[0] - latlngA[0])
          const dLatSin = Math.sin(dLat / 2)
          const dLon = toRad(latlngB[1] - latlngA[1])
          const dLonSin = Math.sin(dLon / 2)

          const a = (dLatSin * dLatSin) +
            (Math.cos(toRad(latlngA[1])) * Math.cos(toRad(latlngB[1])) * dLonSin * dLonSin)
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
          let distance = R * c

          if (isMiles) distance /= 1.60934

          return distance
        }
      }
    },
    dialPhoneFromLocation: function () {
      let _this = this
      let token = localStorage.getItem('token')
      MZCApiService.logInActivityLog(
        token,
        'store',
        _this.location.id,
        'MOBILEAPPWEB_LOCATION_CALL',
        'USER REQUESTED TO CALL LOCATION',
        null,
        _this.locationId
      )
      let _phoneNumber = _this.location.phone_number
      document.location.href = `tel:${_phoneNumber}`
    },
    mapFromLocation: function (fromLat, fromLon, toLat, toLon, myLocation) {
      console.log(fromLat)
      console.log(fromLon)
      console.log(toLat)
      console.log(toLon)

      let _this = this
      let token = localStorage.getItem('token')
      MZCApiService.logInActivityLog(
        token,
        'store',
        _this.location.id,
        'MOBILEAPPWEB_LOCATION_DRIVING_DIRECTIONS',
        'USER REQUESTED DRIVING DIRECTIONS TO LOCATION',
        null,
        _this.locationId
      )
      if (window.cordova) {
        window.launchnavigator.navigate(
          [toLat, toLon],
          [fromLat, fromLon],
          function () {
          },
          function (error) {
            console.log(error)
            let urlMap = 'http://maps.apple.com/?q=' + toLat + ',' + toLon
            window.open(urlMap, '_blank')
          })
      } else {
        let urlMap = 'http://maps.apple.com/?q=' + toLat + ',' + toLon
        window.open(urlMap, '_blank')
      }
    },
    openMapView: function (type) {
      let _this = this
      _this.id = _this.$route.params.id
      _this.locationId = _this.$route.params.location_id
      _this.$router.push('/' + type + '/' + _this.id + '/location/' + _this.locationId + '/map')
    },
    webFromLocation: function () {
      let _this = this
      let token = localStorage.getItem('token')
      MZCApiService.logInActivityLog(
        token,
        'store',
        _this.location.id,
        'MOBILEAPPWEB_LOCATION_WEBSITE',
        'USER REQUESTED TO VISIT WEBSITE',
        null,
        _this.locationId
      )
      let _website = _this.location.meta_data.website
      window.open(
        _website,
        '_blank' // <- This is what makes it open in a new window.
      )
    },
    openGiftCard: function () {
      let _this = this
      _this.$router.push('/gift-cards/received')
    },
    requestLocation (fn) {
      this.$store.dispatch('requestLocation')
        .then(response => {
          if (fn) {
            fn(response)
          }
        })
        .catch(err => console.log(err))
    }
  },
  watch: {},
  mounted: function () {
    this.$nextTick(function () {
      Hub.$on('payload-ready-redemption-process', this.redemptionValidationProcess)
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/coreMixin.js